import Vue from 'vue'
import VueI18n from 'vue-i18n'

import hr from './lang/hr.json'
import bs from './lang/bs.json'
import sr from './lang/sr.json'
import sr_ba from './lang/sr_ba.json'
import mn from './lang/mn.json'
import mk from './lang/mk.json'
import en from './lang/en.json'
import al from './lang/al.json'

Vue.use(VueI18n)

const messages = {
  en:en,
  bs: bs,
  hr: hr,
  sr: sr,
  sr_ba: sr_ba,
  mk:mk,
  mn:mn,
  al:al

}

const locale = localStorage.getItem('language') ? localStorage.getItem('language') : 'hr'

const i18n = new VueI18n({
  locale: locale, // set locale
  fallbackLocale: 'hr',
  messages: messages // set locale messages
})

export default i18n




